import React from 'react';
import { Card, CardBody, Row, Col } from 'reactstrap';
import logo from '../assets/registrarmvsu.jpg';

export default function Registrarmessage() {
    return (
        <div className="container my-5">
            <Card className="shadow-lg border-0">
                <CardBody className="p-4 p-md-5">
                    <Row className="align-items-start">
                        {/* Registrar Image */}
                        <Col md={3} className="text-center" style={{ marginTop: "5.5rem" }}>
                            <img
                                src={logo}
                                alt="Registrar, MVSU"
                                className="img-fluid rounded shadow-sm"
                                style={{ maxHeight: "250px", objectFit: "cover" }}
                            />
                        </Col>

                        {/* Registrar Message */}
                        <Col md={9}>
                            {/* Title */}
                            <div
                                style={{
                                    backgroundColor: "#77236b",
                                    padding: "12px 40px",
                                    borderRadius: "8px",
                                    border: "1px solid #cdd6f3",
                                    boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
                                    color: "#fff",
                                    textAlign: "center",
                                    width: "100%",
                                    marginBottom: "2rem"
                                }}
                            >
                                <h4 className="fw-bold text-white m-0">कुलसचिव सन्देश</h4>
                            </div>

                            {/* Body Content */}
                            <div
                                style={{
                                    textAlign: "justify",
                                    lineHeight: "1.9",
                                    fontSize: "1.1rem",
                                    backgroundColor: "#f9f9f9",
                                    padding: "30px 25px",
                                    borderRadius: "12px",
                                    boxShadow: "0 0 12px rgba(0, 0, 0, 0.12)",
                                    marginBottom: "1.5rem",
                                }}
                            >
                                <p style={{ textIndent: '150px', textAlign: 'justify' }}>
                                    महर्षि वाल्मीकि संस्कृत विश्वविद्यालय अपने उद्देश्यों की पूर्ति हेतु निरन्तर प्रयत्नशील है । यह विश्वविद्यालय संस्कृत भाषा को व्यवहारिक रूप प्रदान करते हुए अपनी परम्परागत शास्त्रीय शैक्षणिक गतिविधियों को संस्कृत भाषा के माध्यम से सम्पन्न कराता है । विश्वविद्यालय की यज्ञशाला विविध प्रकार के यज्ञों, अनुष्ठानों एवं उनके प्रशिक्षण कार्यक्रमों से सतत प्रदीप्त रहती है । इस विश्वविद्यालय में शास्त्री, आचार्य एवं एम.ए. पाठ्यक्रम के साथ-साथ ज्योतिष, वास्तुशास्त्र, कर्मकाण्ड, संस्कृत भाषा दक्षता एवं संगणक प्रयोग सम्बन्धी डिप्लोमा पाठ्यक्रमों को नियमित रूप से अध्ययन-अध्यापन में सम्मिलित किया गया है । यहाँ संस्कृत शिक्षण के साथ-साथ संस्कृत व्यवहार पर भी विशेष बल दिया जाता है ।
                                </p>

                                <p style={{ textIndent: '150px', textAlign: 'justify' }}>
                                    भारतीय ज्ञान-परम्परा के समुचित संरक्षण एवं सम्वर्धन हेतु आवश्यक संसाधनों को प्राध्यापकों, गवेषकों एवं विद्यार्थियों को विशेष रूप से सुलभ कराना हमारा परम उद्देश्य है । विश्वविद्यालय में शैक्षणिक गतिविधियाँ, संस्कृत एवं संस्कृति के प्रचार-प्रसार का कार्य सहजता से आगे बढ़ रहा है । विश्वविद्यालय के नवनिर्माण एवं अन्य आधारभूत सुविधाओं को उपलब्ध कराने के लिए अलग अनुभाग कार्यरत है । वर्तमान में यह विश्वविद्यालय डॉ. भीम राव अम्बेडकर राजकीय महाविद्यालय, जगदीशपुरा एवं कैथल-कुरुक्षेत्र मार्ग पर टीक गाँव के समीप दो परिसरों से संचालित है । विश्वविद्यालय का स्थाई भवन कैथल के गाँव मून्दड़ी में निर्माणाधीन है । ज्ञान अवगाहन की विशिष्ट परम्परा को अक्षुण्य बनाए रखने के लिए नियमित रूप से व्याख्यानमालाओं, कार्यशालाओं एवं संगोष्ठियों का आयोजन किया जाता है ।
                                </p>

                                <p style={{ textIndent: '150px', textAlign: 'justify' }}>
                                    विश्वविद्यालय में शोध को बढ़ावा देने के लिए पाँच शोध-पीठों की स्थापना की गई है । अभी तक विश्वविद्यालय ने पाँच महत्वपूर्ण प्रकाशन भी किए हैं । साथ ही विश्वविद्यालय द्वारा ‘कापिष्ठलम्’ नामक षाण्मासिक शोध पत्रिका भी प्रकाशित की जाती है । प्रचार-प्रसार की दृष्टि से विश्वविद्यालय की गतिविधियों को प्रकाशित करने के लिए ‘महर्षि प्रभा’ नामक ई-पत्रिका का प्रकाशन भी किया जाता है । महर्षि वाल्मीकि संस्कृत विश्वविद्यालय अपने उद्देश्यों की पूर्ति की दिशा में सक्रिय है। विश्वविद्यालय की प्रतिष्ठा का देश-विदेश में विस्तार करने हेतु अनेक प्रकार के सार्थक प्रयास पारस्परिक सहयोग से निरन्तर चल रहे हैं।
                                </p>

                                {/* Signature */}
                                <div className="text-end mt-4 pt-3 border-top">
                                    <p className="mb-0 fw-semibold">प्रो. संजय कुमार गोयल</p>
                                    <p className="text-muted small">कुलसचिव</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </div>
    );
}
